import React, { ReactElement, memo, FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { TestID } from '../../utils/PropTypesDefinitions'
import SkeletonBar from '../SkeletonHelpers/SkeletonBar'
import SmallBodyFont from '../../Theme/Fonts/SmallBody'

export type LightMatchCardSkeletonProps = {
    horizontal?: boolean
} & TestID

const LightMatchCardSkeleton: FunctionComponent<LightMatchCardSkeletonProps> = ({
    horizontal,
    testID,
}): ReactElement => {
    return (
        <Grid minWidth={0} horizontal={horizontal} noExpand backgroundColor="pearl" testID={testID}>
            <Grid
                paddingY={['12px', '12px', '12px', '7px']}
                paddingX={[11, 11, 11, 3]}
                minWidth={0}
                width="100%"
                horizontal
                position="relative"
            >
                <Grid minWidth={0} horizontal centerVertical minHeight={[0, 0, 0, 30]}>
                    <Grid horizontal centerVertical alignRight>
                        <SkeletonBar width={55} height={14} />
                        <Grid
                            noExpand
                            width={16}
                            height={16}
                            backgroundColor="moon-3"
                            borderRadius={4}
                            marginLeft={3}
                        />
                    </Grid>
                    <Grid noExpand width={58} centerHorizontal>
                        <SmallBodyFont textAlign="center">-</SmallBodyFont>
                    </Grid>
                    <Grid horizontal centerVertical>
                        <Grid
                            noExpand
                            width={16}
                            height={16}
                            backgroundColor="moon-3"
                            borderRadius={4}
                        />
                        <SkeletonBar width={55} height={14} marginLeft={3} />
                    </Grid>
                </Grid>
            </Grid>
            <Grid
                noExpand
                horizontal
                width={horizontal ? 342 : '100%'}
                marginTop={horizontal ? 3 : 0}
                marginRight={34}
                marginBottom={horizontal ? 0 : 5}
            >
                <SkeletonBar minWidth={16} width={16} height={10} marginTop={10} />
                <SkeletonBar height={22} marginTop={2} marginLeft={3} borderRadius={2} />
                <SkeletonBar height={22} marginTop={2} marginLeft={3} borderRadius={2} />
                <SkeletonBar minWidth={36} width={36} height={14} marginTop={3} marginLeft={3} />
            </Grid>
        </Grid>
    )
}

export default memo(LightMatchCardSkeleton)
